export default "__VITE_ASSET__2LU_eC3y__"